// extracted by mini-css-extract-plugin
module.exports = {"root":"RichTextEditor__root___2bxzm"};